import React, { Component } from "react";
import PanelHeader from "../../components/PanelHeader/PanelHeader";
import { Card, CardBody, Col, CardHeader, Row } from "reactstrap";
import ConfiguratorTable from "../../components/Configurator/ConfiguratorTable";
import axios from "axios";

class FormsList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      budgets: [],
    };
  }
  componentDidMount() {
    axios
      .post("https://dev.nadu.xyz/dev/configurator/getBudgets")
      .then((res) => {
        if (typeof res !== "undefined") {
          this.setState({ budgets: res.data });
        }
      });
  }

  render() {
    return (
      <div>
        <PanelHeader size="sm" />
        <div className="content">
          <Row>
            <Col xs={12}>
              <Card>
                <CardHeader>
                  <h5>Lista</h5>
                </CardHeader>
                <CardBody>
                  <ConfiguratorTable budgets={this.state.budgets} />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

export default FormsList;



// WEBPACK FOOTER //
// ./src/views/Configurator/FormsList.jsx